module.exports = __webpack_public_path__ + "static/media/BusseltonDunsborougTimes-devicecomp-min@2x.398f42c3.webp";